import { useEffect } from "react";
import { TemplateServiceApi } from "../../service/api/TemplateServiceApi";
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
import TemplateMonitorRowAttributes from "./TemplateMonitorRowAttributes";
import TemplateMonitorRowCF from "./TemplateMonitorRowCF";

import styles from "./TemplateMonitor.module.css";
import gStyles from "./TemplateMonitorGlobalStyles.module.css";

import useTemplateMonitorLogic from "./useTemplateMonitorLogic";
import Loading from "../../components/Loading/Loading";
import GenericModal from "../../UI/GenericModal";
import { useDispatch } from "react-redux";
import { ControlFunctionServiceApi } from "../../service";
import GenericInputModal from "../../UI/GenericInputModal/GenericInputModal";
import { useState } from "react";
import InfoIconWithTooltip from "../../UI/InfoIconWithTooltip/InfoIconWithTooltip";
import { isSuperuserValue } from "../../access/access";

import { useHistory } from "react-router-dom";

const hierarchyArray = ["question", "ambito", "requisito", "principio", "fatQual"]; // in this order so that for example fatQual > requisito
const ATTRDRIVERS = ['Completeness', 'Accuracy', 'Effectiveness', 'Reliability', 'Poor', 'Unsatisfactory', 'Good'];

const TemplateMonitor = (props) => {
  const {
    /* state */
    setError,
    isLoading, setIsLoading,
    isLoadingButtons,
    finalData,
    originalData,
    areAttributesShown,
    allControlFunctions,
    selectedControlFunctionId,
    selectedOpScopes, setSelectedOpScopes,
    modalShow,
    modalAction,
    modalTitle,
    modalMessage,
    modalType,
    /* functions */
    initialConfiguration,
    // changeSupervisedEntityHandler,
    // changeNotSupervisedEntityHandler,
    changeMainAttributeHandler,
    changeAttrDriverHandler,
    changeQntAttrDriverHandler,
    tickingOpScopeHandler,
    untickingOpScopeHandler,
    addQuestionHandler,
    addAmbitoHandler,
    toggleAmbitoHandler,
    removeQuestionHandler,
    removeAmbitoHandler,
    updateQuestionTitleHandler,
    updateAmbitoTitleHandler,
    attributeTabIsValidHandler,
    controlFunctionTabsAreValidHandler,
    dataValidationHandler,
    modalDataHandler,
    modalCloseHandler,
    collapseElement,
    updateTooltipHandler,
  } = useTemplateMonitorLogic(); // custom hook (could be named as useTemplateMonitorLogic)

  const history = useHistory();

  // COMPONENT DID MOUNT
  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    let mounted = true; // used to make sure that the component is still mounted before updating data in this component to avoid problems
    setIsLoading(true);

    const controlFunctionServiceApi = new ControlFunctionServiceApi();
    controlFunctionServiceApi.getAllControlFunctions((cFunctionsError, cFunctions) => {
      if (mounted) { // making sure that the component is still mounted before updating any state
        if (!cFunctionsError) {
          console.log("Control functions & operational scopes API: ", cFunctions);
          const templateServiceApi = new TemplateServiceApi();
          templateServiceApi.getTemplateMonitor((fatQualError, fattoriQualificanti) => {
            console.log("template monitor data ", fattoriQualificanti);
            if (mounted) { // making sure that the component is still mounted before updating any state
              if (!fatQualError) {

                initialConfiguration(cFunctions, fattoriQualificanti);
              } else {
                setError(() => {
                  throw new Error("");
                })
              }
            }
          });
        } else {
          setError(() => {
            throw new Error("");
          })
        }
      }
    });

    // initialConfiguration(cFunctions, localFatQualificantiData);
    // console.log("componentDidMount");

    return () => {
      mounted = false;
    }
  }, []); //finalData.length  

  const renderHeader = () => {
    return (
      <thead className={styles.tableTHead}>
        <tr>
          <th className={`${styles.fatQual} bg-white border-bottom-0`}></th>
          <th className={`${styles.bgGrey} ${styles.questionsWidth} ${styles.increasedFontSize} text-white align-middle`}>
            Questions
          </th>

          <th className={styles.whiteSpaceHeader}></th>

          {areAttributesShown && <th className={`${styles.mainAttrs} ${styles.bgGrey} text-white`}>Main Attributes</th>}
          {/* {areAttributesShown && <th className={`${styles.supervisedEntity} ${styles.bgGrey} text-white`}>Not Supervised Entity</th>} */}
          {areAttributesShown && <th className={`${gStyles.tooltip} ${styles.bgGrey} text-white`}>Description</th>}
          {areAttributesShown && ATTRDRIVERS.map((driver, index) => (
            <th key={driver + '-' + index} className={`${gStyles.opScopeWidth} ${styles.opScopes} ${styles.bgGrey} text-white py-1 px-2`} >{driver}</th> // there is also padding on the styles. Remove one of the two
          ))}

          {!areAttributesShown && finalData && selectedOpScopes.map(opScope => (
            <th key={opScope.name + " " + opScope.id}
              className={`${gStyles.opScopeWidth} ${styles.opScopes} ${styles.bgGrey} position-relative text-white py-1 px-2`}
              onMouseEnter={(e) => showOpScopeInfoIcon(e, opScope.id)}
              onMouseLeave={(e) => hideOpScopeInfoIcon(e, opScope.id)}
            >
              {opScope.name}
              {/* <InfoIconWithTooltip text={opScope.tooltip ? opScope.tooltip : "Description not available"} show={opScope.infoIconIsVisible} /> */}
              {opScope.tooltip ? <InfoIconWithTooltip text={opScope.tooltip} show={opScope.infoIconIsVisible} /> : ""}
            </th>
          ))}
        </tr>

      </thead>
    );
  }

  const showOpScopeInfoIcon = (e, osId) => {
    e.preventDefault();

    const updatedOpScopes = [...selectedOpScopes];
    updatedOpScopes.filter(os => os.id === osId)[0].infoIconIsVisible = true;

    setSelectedOpScopes(updatedOpScopes)
  };

  const hideOpScopeInfoIcon = (e, osId) => {
    e.preventDefault();

    const updatedOpScopes = [...selectedOpScopes];
    updatedOpScopes.filter(os => os.id === osId)[0].infoIconIsVisible = false;

    setSelectedOpScopes(updatedOpScopes)
  };

  // if (originalData) console.log("originalData ", originalData
  //   .filter(fq => fq.id === 1)[0].templateCosoPrincipi
  //   .filter(pr => pr.id === 1)[0].templateCosoRequisiti
  //   .filter(req => req.id === 1)[0].templateCosoAmbiti
  //   .filter(amb => amb.id === 1)[0].templateQualitativeQuestions
  //   .filter(amb => amb.id === 1)[0].templateQuantitativeQuestions
  //   //   .filter(qst => qst.id === 106)[0]
  // );
  console.log('final original data: ', originalData);
  console.log("finalData: ", finalData);

  let transformedData = finalData && [...finalData];

  let fatQualSpan = 0;
  for (let i = transformedData.length - 1; i >= 0; i--) {
    let el = transformedData[i];
    if (el.type && el.type === "fatQual") { // we don't count the elements that are hidden
      el.span = fatQualSpan;
      fatQualSpan = 0;
    } else {
      if (!el.isHidden)
        fatQualSpan++;
    }
  }

  let principioId = 1;
  let tableData = transformedData && transformedData.map((el, index) => {
    if (el.type === "principio") {
      principioId = el.id;
    }
    if (el.type && el.type === "fatQual") {
      return (
        <tr key={el.type + "-" + el.id}>
          {/* style={{background: `rgb(${red+=9}, ${green+=26}, ${blue+=16})`}} */}
          <td className={styles.fatQual} rowSpan={el.span + 1}>
            <span className={styles.verticalText}>{el.title}</span>
          </td>
        </tr>
      );
    } else {
      if (!el.isHidden) {
        return areAttributesShown ? (
          <TemplateMonitorRowAttributes
            key={
              el.type
                ? el.type + "-" + el.id
                : "question-" + index
            }
            title={el.title}
            type={el.type}
            pos={index}
            // questionType={el.questionType} 
            isQualitative={el.isQualitative}
            mainAttrs={el.mainAttributes}
            attrDrivers={el.attributesDrivers}
            isCollapsed={el.isCollapsed}
            hasValidChildren={el.hasValidChildren}
            isEmpty={el.isEmpty}
            // tooltip={(Math.floor(Math.random() * 10) % 2 === 0) ? "This is a tooltip" : ""}
            deletable={el.isDeletable}
            isActive={el.active}
            good={el.good}
            bad={el.bad}
            poor={el.poor}
            unsatisfactory={el.unsatisfactory}
            tooltip={el.tooltip}
            principioId={principioId}
            displayId={el.displayId}
            changeMainAttribute={changeMainAttributeHandler}
            changeAttrDriver={changeAttrDriverHandler}
            changeQntAttrDriver={changeQntAttrDriverHandler}
            addQuestion={addQuestionHandler}
            addAmbito={addAmbitoHandler}
            toggleAmbito={toggleAmbitoHandler}
            removeQuestion={removeQuestionHandler}
            removeAmbito={removeAmbitoHandler}
            updateQuestionTitle={updateQuestionTitleHandler}
            updateAmbitoTitle={updateAmbitoTitleHandler}
            modalDataHandler={modalDataHandler}
            invalidInputs={el.invalidInputs}
            collapseElement={collapseElement}
            updateTooltipHandler={updateTooltipHandler}
          />
        ) : (
          <TemplateMonitorRowCF
            key={
              el.type
                ? el.type + "-" + el.id
                : el.questionType + "-" + index
            }
            title={el.title}
            cfId={selectedControlFunctionId}
            opScopes={el.conFuncOpScopes[selectedControlFunctionId]}
            type={el.type}
            pos={index}
            isCollapsed={el.isCollapsed}
            principioId={principioId}
            ambitoId={el.ambitoId}
            displayId={el.displayId}
            hasValidChildren={el.hasValidChildren}
            uncheckingOpScope={untickingOpScopeHandler}
            checkingOpScope={tickingOpScopeHandler}
            invalidInputs={el.invalidInputs}
            collapseElement={collapseElement}
            isQualitative={el.isQualitative}
            isActive={el.active}
          />
        );
      }
    }
  });

  const tableStyle = `${styles.table} text-center table`;
  let table = (
    <table className={`${tableStyle} ${styles.tableRelative}`}>
      <tbody>
        {tableData}
      </tbody>
    </table>
  );

  let buttonsMenuStyle;
  const osLength = (selectedControlFunctionId !== 0) && selectedOpScopes.length;
  if (areAttributesShown) {

  } else {
    buttonsMenuStyle = {
      width: `calc(100vw * 0.07 * ${osLength} * 2)`,
      minWidth: `calc(95px * ${osLength}`,
      maxWidth: `130px * ${osLength}`
    }
  }

  return (
    <div className={`position-relative ${styles.outerDiv} ${styles.responsiveElements}`}>
      <div className={styles.innerContainerDiv}>
        {/* ERRORS BAR */}
        {!isLoading && <div className={`${styles.errorsBar} d-flex flex-column justify-content-between align-items-end`}>
          {transformedData.length > 0 && transformedData.map((el, index) => {
            let questionHasError = false;
            if (!el.type || el.type === "ambito") {
              for (const value of Object.values(el.invalidInputs)) {
                if (value === true) {
                  questionHasError = true;
                  break;
                }
              }
            }
            if (!el.isHidden) {
              return (
                <div
                  key={
                    el.type ? (el.id + '-' + index) : (el.questionId + '-' + index)
                  }
                  className={((!el.type && questionHasError) || (el.type && !el.hasValidChildren)) ? styles.barErrorBox : styles.barCommonBox}></div>
              )
            } else {
              return "";
            }
          })}
        </div>}
        <GenericModal
          show={modalShow}
          handleClose={modalCloseHandler}
          action={modalAction}
          title={modalTitle}
          message={modalMessage}
          modalType={modalType}
        />
        {/* <GenericInputModal
          show={inputModalShow}
          handleClose={inputModalCloseHandler}
          content={inputModalContent}
          inputModalAction={inputModalAction}
        /> */}

        {/* HEAD OPTIONS MENU */}
        {!isLoading && <div className={styles.headMenu}>
          {/* <h6 className={styles.questionLabel}>Edit Framework's Questions</h6> */}
          <div className={`${styles.tabSelectionButtonContainer}`} style={buttonsMenuStyle}>
            <button
              className={`${styles.tabSelectionButton} ${areAttributesShown ? "nexiBgColorLight" : "nexiBgColorVeryLight"}`}
              style={{ fontSize: "1.1em" }}
              onClick={controlFunctionTabsAreValidHandler}>
              Attributes
            </button>
            {allControlFunctions.map(cf => {
              return (
                <button
                  key={cf.id + '-' + cf.name}
                  className={`${styles.tabSelectionButton} ${cf.id == selectedControlFunctionId ? "nexiBgColorLight" : "nexiBgColorVeryLight"}`}
                  onClick={() => { attributeTabIsValidHandler(cf.id) }}>
                  {cf.name}
                </button>
              )
            }
            )}
          </div>
        </div>}
        {isLoading && <Loading />}
        {!isLoading && ( // Rendering the header separately from the body as the solution for the sticky header functionality
          <table className={`${tableStyle} ${styles.stickyHeader} mb-0`}>
            {renderHeader()}
          </table>
        )}
        {!isLoading && table}

      </div>
      <div className={`${styles.submitButtonContainer} d-flex justify-content-center`}>
        {!isLoadingButtons && !isLoading && <SubmitButton
          click={dataValidationHandler}
        >
          Update Framework
        </SubmitButton>}
        {isLoadingButtons && <Loading />}
        {" "}
        {/*  */}
      </div>
    </div>
  );
}

export default TemplateMonitor;
